export const styleOverrides = {
  root: ({ theme }) => ({
    borderRadius: "2px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    padding: "12px 16px",
    fontSize: "0.875rem",
    alignItems: "flex-start",
    "& .MuiAlert-icon": {
      fontSize: "22px",
      marginRight: "12px",
      marginTop: "2px",
      opacity: 1,
    },
    "& .MuiAlert-message": {
      padding: "0",
      color: "#161616",
    },
    "& .MuiAlert-action": {
      paddingTop: "0",
      marginRight: "-8px",
      padding: "0 0 0 16px",
      color: "#161616",
    },
  }),
  standardSuccess: {
    backgroundColor: "#defbe6",
    borderLeft: "4px solid #24a148",
    "& .MuiAlert-icon": {
      color: "#24a148",
    },
  },
  standardError: {
    backgroundColor: "#fff1f1",
    borderLeft: "4px solid #da1e28",
    "& .MuiAlert-icon": {
      color: "#da1e28",
    },
  },
  standardWarning: {
    backgroundColor: "#fdf3e1",
    borderLeft: "4px solid #f1c21b",
    "& .MuiAlert-icon": {
      color: "#f1c21b",
    },
  },
  standardInfo: {
    backgroundColor: "#edf5ff",
    borderLeft: "4px solid #0043ce",
    "& .MuiAlert-icon": {
      color: "#0043ce",
    },
  },
};
